// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedArtevoDefault_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 0V4H11V5H7V19C7.76835 19 8.46924 19.2889 9 19.7639V7H15V19.7639C15.5308 19.2889 16.2316 19 17 19V5H13V4H23V0H21V2H3V0H1ZM9.23607 20C9.71112 20.5307 9.99999 21.2316 10 22H14C14 21.2316 14.2889 20.5307 14.7639 20H9.23607ZM6.99992 24C8.10449 24 8.99992 23.1046 8.99992 22 8.99992 20.8954 8.10449 20 6.99992 20 5.89535 20 4.99992 20.8954 4.99992 22 4.99992 23.1046 5.89535 24 6.99992 24ZM16.9999 24C18.1045 24 18.9999 23.1046 18.9999 22 18.9999 20.8955 18.1045 20 16.9999 20 15.8953 20 14.9999 20.8955 14.9999 22 14.9999 23.1046 15.8953 24 16.9999 24Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedArtevoDefault is a generated icon component.
 */
let IconMedArtevoDefault = IconMedArtevoDefault_1 = class IconMedArtevoDefault extends IconBaseElement {
    render() {
        return html `${IconMedArtevoDefault_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedArtevoDefault.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedArtevoDefault = IconMedArtevoDefault_1 = __decorate([
    customElement('zui-icon-med-artevo-default')
], IconMedArtevoDefault);
export { IconMedArtevoDefault };
